import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';

/** Land at the top of each screen — deep pages used to inherit the
 *  marketplace's scroll offset and open halfway down. */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Layout = () => (
  <>
    <ScrollToTop />
    <Navbar />
    <Outlet />
  </>
);

export default Layout;
